import { render } from "./Calculation.vue?vue&type=template&id=bb30cd56"
import script from "./Calculation.vue?vue&type=script&lang=ts"
export * from "./Calculation.vue?vue&type=script&lang=ts"
script.render = render

export default script